module.exports = __webpack_public_path__ + "img/new11_1_3.dfcc01ba.png";